import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { takeLatest } from 'redux-saga/effects'
import { ICreateContract } from '../createContract/ICreateContract'
import { IDatosContrato } from '../../../app/pages/minutas/minutaFood/minutaDTO'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetContracts: '[Set Contracts] Action',
  SetContract: '[Set Contract] Action',
  SetInfo: '[Set Info] Action',
  SetInfoData: '[Set Info Data] Action',
  SetInfoPlantilla: '[Set Info Plantilla] Action',
  SetAlgo: '[Set Algo] Action',
}

const initialContractState: IContractState = {
    contracts: [],
    contract: undefined,
    info: false,
    infoData: undefined,
    infoPlantilla: undefined,
    algo: null,
}


export interface IContractState {
    contracts?: ICreateContract[],
    contract?: ICreateContract,
    info?: boolean,
    infoData?: IDatosContrato | undefined,
    infoPlantilla?: any | undefined,
    algo: any,
}

export const reducer = persistReducer(
  { storage, key: 'v100-demo1-contract', whitelist: ['contracts'] },
  (state: IContractState = initialContractState, action: ActionWithPayload<IContractState>) => {
    switch (action.type) {
      case actionTypes.SetContracts: {
        const contracts = action.payload?.contracts
        return { ...state, contracts }
      }

      case actionTypes.SetContract: {
        const contract = action.payload?.contract
        return { ...state, contract }
      }

      case actionTypes.SetAlgo: {
        const algo = action.payload?.algo
        return { ...state, algo }
      }

      case actionTypes.SetInfo: {
        const info = action.payload?.info
        return { ...state, info }
      }

      case actionTypes.SetInfoData: {
        const infoData = action.payload?.infoData
        return { ...state, infoData }
      }
      
      case actionTypes.SetInfoPlantilla: {
        const infoPlantilla = action.payload?.infoPlantilla
        return { ...state, infoPlantilla }
      }

      default:
        return state
    }
  }
)

export const actions = {
    setContracts: (contracts: ICreateContract[]) => ({ type: actionTypes.SetContracts, payload: { contracts } }),
    setContract: (contract: ICreateContract) => ({ type: actionTypes.SetContract, payload: { contract } }),
    setAlgo: (algo: any) => ({ type: actionTypes.SetAlgo, payload: { algo } }),
    setInfo: (info: boolean) => ({ type: actionTypes.SetInfo, payload: { info } }),
    setInfoData: (infoData: IDatosContrato | undefined) => ({ type: actionTypes.SetInfoData, payload: { infoData } }),
    setInfoPlantilla: (infoPlantilla: any | undefined) => ({ type: actionTypes.SetInfoPlantilla, payload: { infoPlantilla } }),
    
}

export function* saga() {
  yield takeLatest(actionTypes.SetContracts, function* loginSaga() {
    // yield put(actions.requestUser())
  })
}

